export default "__VITE_ASSET__kR8XpMiQ__"